import firebase from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBDSWfNFpgOQxmp6WPidOnv_tDQvpgPWag",
  authDomain: "wiom-47e95.firebaseapp.com",
  projectId: "wiom-47e95",
  storageBucket: "wiom-47e95.appspot.com",
  messagingSenderId: "39462096092",
  appId: "1:39462096092:web:83a01ed1a17bec19b17819",
  measurementId: "G-ZMV99GN63K"
};

let messaging = null;
if (firebase && firebase.messaging && firebase.messaging.isSupported()) {
  firebase.initializeApp(firebaseConfig);
  messaging = firebase.messaging();
}
export default {
  messaging
}